import { useState } from 'react';

import { useNavigate } from 'react-router-dom';

import { MenuItem, ListItemIcon, Icon } from '@liscio/ui';

import { ArchiveRequestDialog } from 'modules/requests/dialogs/ArchiveRequestDialog/ArchiveRequestDialog';
import { routes } from 'routes';

interface ArchiveRequestMenuItemProps {
  onClose: () => void;
  requestId: string;
}

export const ArchiveRequestMenuItem = ({
  onClose,
  requestId,
}: ArchiveRequestMenuItemProps) => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const handleClick = () => {
    setOpen(true);
  };

  return (
    <>
      <MenuItem onClick={handleClick}>
        <ListItemIcon>
          <Icon icon="archive" fontSize="small" />
        </ListItemIcon>
        Archive Request
      </MenuItem>
      <ArchiveRequestDialog
        open={open}
        onClose={() => {
          setOpen(false);
          onClose();
        }}
        requestId={requestId}
        onSuccessfulRecall={() => {
          navigate(routes.requestsListProtected.link());
        }}
      />
    </>
  );
};
